<template>
  <!-- 智能拓客平台 -->
  <div class="ab-customer-platform clearfix">
    <div class="warp">
      <AbBlock :title="title" :subTitle="subTitle">
        <div class="platform-list flex-row justify-between">
          <div
            :key="index"
            :style="
              overIndex ? (overIndex === index + 1 ? scaleX : vScaleX) : ' '
            "
            v-for="(item, index) in list"
            :ref="'list' + index"
            @mouseover="blockEventOver(index)"
            @mouseout="blockEventOut"
          >
            <span
              class="platform-list-pic"
              :style="{
                backgroundImage:
                  'url(' + require(`@/assets/${item.image}`) + ')',
              }"
            >
              <b></b>
              <p>
                <em>{{ item.title }}</em>
                <i
                  >{{ item.content }}
                  <a
                    @click="showModal"
                    data-source="p"
                    onmouseover="linkDataSource(this)"
                    a-type="register"
                    target="_blank"
                    >免费试用</a
                  ></i
                >
              </p>
            </span>
          </div>
          <!-- <div>
            <span
              class="platform-list-pic"
              :style="{
                'background-image': `url('~@/assets/product/全球追踪分析.jpg')`,
              }"
            >
              <p>
                <em></em>
                <i
                  >
                  <a href="https://crm.cnabke.com/#/passport/register" data-source="p" onmouseover="linkDataSource(this)"    a-type="register"   target="_blank" 
                    >免费试用</a
                  ></i
                >
              </p>
            </span>
          </div>
          <div>
            <span
              class="platform-list-pic"
              :style="{
                'background-image': `url('~@/assets/product/大数据精准获客.jpg')`,
              }"
            >
              <p>
                <em></em>
                <i
                  >
                  <a href="https://crm.cnabke.com/#/passport/register"  data-source="p"  onmouseover="linkDataSource(this)"    a-type="register"   target="_blank"
                    >免费试用</a
                  ></i
                >
              </p>
            </span>
          </div>
          <div>
            <span
              class="platform-list-pic"
              :style="{
                'background-image': 'url('++')',
              }"
            >
              <p>
                <em></em>
                <i
                  >
                  <a href="https://crm.cnabke.com/#/passport/register"  data-source="p"  onmouseover="linkDataSource(this)"    a-type="register"  target="_blank"
                    >免费试用</a
                  ></i
                >
              </p>
            </span>
          </div> -->
        </div>
      </AbBlock>
    </div>
    <inquiry-modal-vue
      :visible="visible"
      @cancel="handleCancel"
    ></inquiry-modal-vue>
  </div>
  <!-- 智能拓客平台 -->
</template>

<script>
// import $ from 'jquery';
import AbBlock from "@/components/AbBlock.vue";
import inquiryModalVue from "@/components/InquiryModal2.vue";
import { usePageTracker } from "@/utils/pageTracker";
// require('@/assets/product/海量外贸数据支持.jpg');
export default {
  components: {
    AbBlock,
    inquiryModalVue,
  },
  props: {
    blockTitle: {
      type: String,
      default: "",
    },
    blockSubTitle: {
      type: String,
      default: "",
    },
    blockList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      title: this.blockTitle,
      subTitle: this.blockSubTitle,
      list: this.blockList,
      visible: false,
      scaleX: {
        // transform: 'scaleX(1.234)',
        width: "31%",
      },
      vScaleX: {
        // transform: 'scaleX(0.9185)',
        width: "23%",
      },
      overIndex: 0,
    };
  },
  mounted() {},
  methods: {
    blockEventOver(index) {
      this.overIndex = index + 1;
    },
    blockEventOut() {
      this.overIndex = 0;
    },
    showModal() {
      usePageTracker().openInNewTab(
        "https://crm.cnabke.com/#/passport/register"
      );
      // window.open("https://crm.cnabke.com/#/passport/register", "_blank");
      this.visible = true;
    },

    handleCancel() {
      this.visible = false;
    },
  },
};
</script>

<style lang="sass" scoped>
  .ab-customer-platform{
    padding-top:70px;
    background:url(~@/assets/product/背景_智能拓客平台.jpg) no-repeat;
    height:761px;
    background-size:cover;

    .platform-list div span p i a{
      width: 180px;
      height: 56px;
      border-radius: 4px;
      border: 2px solid #FFFFFF;
      font-size: 18px;
      font-family: 'Alibaba-PuHuiTi-R';
      color: #FFFFFF;
      display: block;
      text-align:center;
      line-height:54px;
      margin-top:40px;
    }
    .platform-list div span p i a:hover{
      background:#fff;
      color:#198BFF

    }
    .platform-list div span p i {
      color: #fff;
      font-size: 16px;
      opacity: 0;
      height: 0;
      display: block;
      font-family: 'Alibaba-PuHuiTi-R';
      -webkit-transform: translateY(100%);
      -ms-transform: translateY(100%);
      transform: translateY(100%);

      width:375px;
      height:120px;
      line-height: 22px;
    }
    .platform-list div:hover span p i{
      opacity: 1;
      height: 18px;
      margin-top: 10px;
      -webkit-transform: translateY(0);
      -ms-transform: translateY(0);
      transform: translateY(0);
    }
    .platform-list div:hover span p{
      padding-bottom:260px;
    }
    .platform-list span p{
      position: absolute;
      width: 100%;
      left: 0;
      bottom: 0;
      padding: 0 50px 0px 50px;
      margin-bottom:-60px;
      z-index: 4;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      overflow: hidden;
      -webkit-transform: translateY(20px);
      -ms-transform: translateY(20px);
      transform: translateY(20px);

    }
    .platform-list span em{
      font-size:26px;
      color:#fff;
      display: block;
      text-align:center; ransform: translateZ(0);
      transition: all .3s;
      font-family: 'Alibaba-PuHuiTi-R';
    }
    .platform-list div:hover p em{
      font-family: 'AlibabaPuHuiTiM';
      text-align:left;
    }
    .platform-list{
      height: 500px;
      margin:0px -13px;
      margin-top:50px;
    }
    .platform-list div:hover p {
      -webkit-transform: translateY(0);
      -ms-transform: translateY(0);
      transform: translateY(0);

    }
    .platform-list>div{
      &:hover{
        transition: all .3s;
      }
      width: 405px;
      height: 500px;
      padding:0px 13px;
      opacity: .8;
       transform: translateZ(0);
    transition: all .3s;

    }

    .platform-list>div:hover{opacity: 1;}

    .platform-list-pic {
      b{
        background: url('~@/assets/product/遮罩.png')  center center;
        display:block;
        height:100%;
        width:100%;
      }
      background: url('~@/assets/product/海量外贸数据支持.jpg') no-repeat center center;
      display: block;
      overflow: hidden;
      position: relative;
      height:500px;
      width:100%;

    }
    // .platform-list-pic1{background-image: url('~@/assets/product/全球追踪分析.jpg')}
    // .platform-list-pic2{background-image: url('~@/assets/product/大数据精准获客.jpg')}
    // .platform-list-pic3{background-image: url('~@/assets/product/企业实力透视.jpg')}
}
</style>
